module.exports = __webpack_public_path__ + "static/produktentwicklung-df07626abbf213e183c5aedce1f5ccf6.png";